/**
 * Map engine score → evalNorm in [-1, 1] (white-positive).
 * Used by tint / morph; pure and unit-testable.
 */
export function mapEval(score: { cp?: number; mate?: number } | undefined): number {
  if (!score) return 0;
  if (score.mate !== undefined) {
    return score.mate > 0 ? 1 : score.mate < 0 ? -1 : 0;
  }
  if (score.cp === undefined) return 0;
  // Soft clamp ±300cp so modest advantages still move the mood strongly
  const clamp = 300;
  const n = score.cp / clamp;
  return Math.max(-1, Math.min(1, n));
}

/**
 * White's fill of the eval bar in [0, 1].
 * Checkmate is 100% for the winner (`matedSide` is the side that is mated).
 */
export function evalBarWhiteShare(
  score: { cp?: number; mate?: number } | undefined,
  opts: { isStart?: boolean; matedSide?: 'w' | 'b' | null },
): number {
  if (opts.matedSide === 'w') return 0;
  if (opts.matedSide === 'b') return 1;
  if (opts.isStart) return 0.5;
  if (!score) return 0.5;
  return (mapEval(score) + 1) / 2;
}
